import React from "react";

const Token = ({ amount }) => {
  return <p className="inner-box">{amount}</p>;
};

export default Token;
